<template>
  <div class="index">
    <div class="wrap-img" :class="scheme.flag === 'slc90' ? 'slc90' : 'default'" title="Z5"></div>
    <div class="header">
      <div class="title">{{ project.name }}</div>
      <div class="project-intro" v-html="project.intro"></div>
      <div class="desc" v-html="scheme.intro"></div>
    </div>
    <div class="content">
      <img v-if="scheme.flag=='Z5'" src="@assets/images/eval/Z5-start.jpg" class="image"/>
      <img v-else-if="scheme.flag=='Z3-Manage'||scheme.flag=='Z3-Marketer'||scheme.flag=='Z3-Recruitment'"
           src="@assets/images/eval/Z3-start.jpg" class="image"/>
      <img v-else-if="scheme.flag=='fenc-simple'||scheme.flag=='fenc-m'" src="@assets/images/eval/fenc-start.jpg"
           class="image"/>
    </div>

    <div class="footer">
      <vant-button round block color="#315ace" @click="toView" v-if="report.user && report.user.statue == 2">查看结果
      </vant-button>
      <vant-button round block color="#315ace" disabled v-else-if="time<project.startTime">测评未开始</vant-button>
      <vant-button round block color="#315ace" disabled v-else-if="time>project.endTime || project.status ==2">测评已结束
      </vant-button>
      <vant-button round block color="#315ace" @click="toGoOn" v-else-if="report.user && report.user.statue == 1">继续答题
      </vant-button>
      <vant-button round block color="#315ace" @click="toStart" v-else>开始测评</vant-button>
    </div>

    <vant-dialog title="验证码" v-model="show" :show-cancel-button="true" :before-close="submit">
      <field v-model="code" name="验证码" placeholder="请联系管理员获取验证码"/>
    </vant-dialog>
  </div>
</template>
<script>
import {getProjectInfo, getSchemeInfo, getReportInfo, checkPassword} from "@api/eval";
import {mapGetters} from "vuex";
import {Button as VantButton, Dialog as VantDialog, Field, Toast} from "vant";

export default {

  name: "Index",
  computed: {
    ...mapGetters(["token"])
  },

  components: {
    VantButton,
    Field,
    VantDialog: VantDialog.Component//！！！！坑
  },
  data: function () {
    return {
      projectId: this.$route.params.projectId,
      time: new Date().getTime() / 1000,
      project: {},
      report: {},
      show: false,
      code: '',
      scheme: {}
    };
  },
  created: function () {
    this.init();
  },
  methods: {
    submit(action, done) {
      if (action === 'confirm') {
        if (!this.code) {
          Toast.fail("请输入验证码！");
          return done(false);
        }
        checkPassword(this.project.id, {pwd: this.code}).then(res => {
          if (res.result) {
            this.$router.push({path: `/eval/register/${this.projectId}`});
          } else {
            Toast.fail("验证码错误！");
            this.code = ''
            return done(false);
          }
        })
        this.show = false
      } else if (action === 'cancel') {
        done() // 关闭
      }
    },
    init() {
      getProjectInfo(this.projectId).then(res => {
        this.project = res.result || {};
      });
      getSchemeInfo(this.projectId).then(res => {
        this.scheme = res.result || {};
      });
      getReportInfo(this.projectId).then(res => {
        this.report = res.result || null;
      });
    },

    toStart() {
      if (this.project.password) {
        this.toValid()
      } else {
        this.$router.push({path: `/eval/register/${this.projectId}`});
      }
    },
    toView() {
      if (this.project.free == 1) {
        this.$router.replace({path: `/eval/result/${this.projectId}`});
      } else {
        if (this.report.user.payStatus == 1) {
          location.href = `/api/evaluate/report/pdf/${this.report.user.id}/${this.scheme.id}`;
        } else {
          this.$router.replace({path: `/eval/result/${this.projectId}`});
        }
      }
    },
    toGoOn() {
      if (this.scheme.flag === "fenc-m" || this.scheme.flag === "fenc-simple") {
        this.$router.replace({path: `/eval/post/${this.projectId}`});
      } else {
        this.$router.replace({path: `/eval/start/${this.projectId}`});
      }
    },
    toValid() {
      this.show = true
    }
  }
}
;
</script>
<style lang="scss" scoped>
.index {
  background-color: #f5f5f5;
  min-height: 100vh;

  .wrap-img {
    height: 180px;

    &.default {
      background: url("~@images/banner.jpg") 0 0 no-repeat;
      background-size: cover;
    }

    &.slc90 {
      background: url("~@images/banner-slc90.png") 0 0 no-repeat;
      background-size: cover;
    }
  }

  .header {
    padding: 10px 20px;
    background-color: #FFFFFF;

    .title {
      font-size: 18px;
      color: #333333;
      line-height: 30px;
      font-weight: bold;
    }

    .desc {
      font-size: 14px;
      margin-top: 10px;
      line-height: 25px;
      color: #7d7d7d;
    }

    .project-intro {
      font-size: 16px;
      line-height: 30px;
      color: #464646;
      font-weight: 700;
    }

  }

  .content {
    min-height: 200px;
    background-color: #FFFFFF;
    padding: 10px 15px;
    margin-top: 8px;
    display: block;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 60px;

    ::v-deep img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .footer {
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    padding: 10px 30px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }
}
</style>
